import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class ItiGridPagesMixin extends Vue {
    public rowsPerPageItems = [
        10,
        25,
        50,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
      ];
}
